import { type MutationError, trpc } from '@/shared/api';

interface UseCreateCategoryOptions {
  readonly onSuccess?: () => void;
}

/** 카테고리 추가 — parentId 가 null 이면 대분류, 있으면 소분류. */
export const useCreateCategory = ({ onSuccess }: UseCreateCategoryOptions = {}) => {
  const mutation = trpc.productManagement.categories.create.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    createCategory: mutation.mutate,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
